import { useState } from "react";
import { GesecContractsTable } from "@/services/backend/business-central/components/gesec-contracts-table";
import {
  CustomerPageMain,
  CustomerPageMainContent,
  CustomerPageMainHeader,
} from "@/routes/customers/[customerId]/_components/customer-page";
import { CustomerPageBreadcrumbs } from "@/routes/customers/[customerId]/_components/customer-page-breadcrumbs";
import t from "@/lang/lang";
import { useParams } from "react-router";
import { ListGesecContractRequest } from "@/services/backend/business-central/api/gesec-contract-api";
import { useActiveCompany } from "@/shared/lib/active-company/active-company-provider";
import { useBusinessCentralMatchOneToOneShowQuery } from "@/services/backend/business-central/api/match-one-to-one-api";
import { MatchType } from "@/services/backend/business-central/types/match-type";
import { Spinner } from "@/shared/components/ui/spinner";
import { RTKQueryErrorAlert } from "@/shared/components/errors/rtk-query-error-alert";
import { Alert, AlertTitle } from "@/shared/components/ui/alert";
import { AlertTriangle } from "lucide-react";

export function BusinessCentralContractsRoute() {
  const { customerId } = useParams();
  const { companyId } = useActiveCompany();
  const {
    data: match,
    isLoading,
    error,
  } = useBusinessCentralMatchOneToOneShowQuery({
    type: MatchType.CompanyToCompany,
    id: companyId,
  });
  //
  // The customer can only be determined after the
  // sync between Dynamics Sales and Business Central
  // was established.
  const customerNo = "";

  return (
    <CustomerPageMain>
      <CustomerPageMainHeader>
        <CustomerPageBreadcrumbs
          breadcrumbs={[
            {
              to: `/customers/${customerId}/business-central-contracts`,
              label: t("Business Central Verträge"),
            },
          ]}
        />
      </CustomerPageMainHeader>
      <CustomerPageMainContent>
        {isLoading && (
          <span>
            <Spinner />
            {t("Lade Business Central Unternehmen")}
          </span>
        )}
        {error && <RTKQueryErrorAlert error={error} showValidationErrors />}
        {customerNo === "" && <CustomerNotMatchedAlert />}
        {match && customerNo !== "" && (
          <MatchLoadingWrapper
            bcCompanyId={match.bcId}
            bcCustomerNo={customerNo}
          />
        )}
      </CustomerPageMainContent>
    </CustomerPageMain>
  );
}

function MatchLoadingWrapper({
  bcCompanyId,
  bcCustomerNo: bcCustomerId,
}: {
  bcCompanyId: string;
  bcCustomerNo: string;
}) {
  const [request] = useState<ListGesecContractRequest>({
    companyId: bcCompanyId,
    customerNo: {
      active: true,
      values: [bcCustomerId],
    },
  });

  return <GesecContractsTable request={request} />;
}

function CustomerNotMatchedAlert() {
  return (
    <Alert>
      <AlertTriangle />
      <AlertTitle>
        {t(
          "Für den Kunden besteht keine Verknüpfung zwischen Dynamics Sales und Business Central.",
        )}
      </AlertTitle>
    </Alert>
  );
}
